/// <amd-module name="Build/Admin/AgentCloudsList/Flux" />
import { IVssPageContext } from "VSS/Platform/Context";

import { ActionsHub } from "Build/Admin/AgentCloudsList/Actions/ActionsHub";
import { AgentCloudsListActionCreator } from "Build/Admin/AgentCloudsList/Actions/AgentCloudsListActionCreator";
import { StoresHub } from "Build/Admin/AgentCloudsList/Stores/StoresHub";
import { AgentCloudSource } from "Build/Admin/Common/Sources/AgentCloudSource";

export class Flux {
    public actionsHub: ActionsHub;
    public agentCloudSource: AgentCloudSource;
    public agentCloudsListActionCreator: AgentCloudsListActionCreator;
    public storesHub: StoresHub;

    public constructor(pageContext: IVssPageContext) {
        this.actionsHub = new ActionsHub();
        this.agentCloudSource = new AgentCloudSource(pageContext);
        this.storesHub = new StoresHub(this.actionsHub);
        this.agentCloudsListActionCreator = new AgentCloudsListActionCreator({
            pageContext: pageContext,
            actionsHub: this.actionsHub,
            agentCloudSource: this.agentCloudSource,
            storesHub: this.storesHub
        });
    }
}
